module.exports = __webpack_public_path__ + "images/8655f302341fa0bcc68d91d3120ad9c6.png";